// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SortAscendingOutlinedSvg from "@fishx/icons-svg/es/asn/SortAscendingOutlined";
import FishxIcon from '../components/FishxIcon';

var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SortAscendingOutlinedSvg
  }));
};

SortAscendingOutlined.displayName = 'SortAscendingOutlined';
export default React.forwardRef(SortAscendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SortAscendingOutlined.js
// module id = 4172
// module chunks = 0